export default {
    apiKey: process.env.VUE_APP_API_KEY ?? "areaijhew984343adsade",
    authDomain: process.env.VUE_APP_AUTHDOMAIN ?? "gorda.driver",
    projectId: process.env.VUE_APP_PROJECT_ID ?? "gorda-driver",
    storageBucket: process.env.VUE_APP_STORAGE_BUCKET ?? "gorda-driver",
    messagingSenderId: process.env.VUE_APP_MESSAGING_ID ?? "12345678900",
    appId: process.env.VUE_APP_APP_ID ?? "1:412940684394:web:40f1a71786e91a53040e13",
    measurementId: process.env.VUE_APP_MEASUREMENT_ID ?? "G-858886884",
    databaseURL: process.env.VUE_APP_DATABASE_URL ?? "http://127.0.0.1:9000/?ns=gorda-driver-default-rtdb",
}

